import CryptoJS from 'crypto-js'
import md5 from 'js-md5';

var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
function generateMixed(n) {
    var res = "";
    for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 35);
        res += chars[id];
    }
    return res;
}
var encrypt = (word, keyStr)=>{
    keyStr = keyStr ? keyStr : 'sgy459sf03#$5^&b';
    var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv:CryptoJS.enc.Utf8.parse('1234567890123456')
    });
    return encrypted.toString();
}

var decrypt = (word, keyStr)=>{
    keyStr = keyStr ? keyStr : 'sgy459sf03#$5^&b';
    var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv:CryptoJS.enc.Utf8.parse('1234567890123456')
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
const clientType = 'web'

var headersSign = ()=>{
    const random = generateMixed(16)
    var time = (new Date()).valueOf()
    var key = md5(clientType + random + time)
    return encrypt('client_type=' + clientType + '&random=' + random + '&time=' + time + '&key='+key)
}

var WeiXinSign = (backUrl)=>{
    var singParam = 'utRWZBhNvI'
    var state = {
        back:backUrl,
        sign:md5(backUrl+singParam)
    }
    return btoa(JSON.stringify(state))
}

var UrlEncode = (string)=>{
    if(typeof string  != 'string'){
        return string
    }
    string = string.replace(/\r\n/g,"\n");
			var utftext = "";
			for (var n = 0; n < string.length; n++){
				var c = string.charCodeAt(n);
				if (c < 128){
					utftext += String.fromCharCode(c);
				}
				else
				if((c > 127) && (c < 2048)){
					utftext += String.fromCharCode((c >> 6) | 192);
					utftext += String.fromCharCode((c & 63) | 128);
				}
				else{
					utftext += String.fromCharCode((c >> 12) | 224);
					utftext += String.fromCharCode(((c >> 6) & 63) | 128);
					utftext += String.fromCharCode((c & 63) | 128);
				}
			}
			return utftext;
  }

export default {
    //加密的头部clientType
    clientType,
    //加密的头部sign
    headersSign,
    //加密
    encrypt,
    //解密
    decrypt,
    //微信Sign加密
    WeiXinSign,
    //UrlEncode
    UrlEncode
}

